<template>
  <div class="wind grid">
    <font-awesome-icon icon="wind" class="icon" />
    <div class="wind__speed current">
      <span class="primary">{{ roundedSpeed }}</span>
      <span class="unit">m/s</span>
    </div>
    <div class="wind__direction extra">
      <font-awesome-icon icon="long-arrow-alt-up" class="unit" :style="{ transform: 'rotate('+ direction+'deg)'}" />
      <span>{{ textual }}</span>
    </div>
  </div>
</template>

<script>
export default {
name: "wind",

props: {
  direction: {
    type: Number
  },
  speed: {
    type: Number
  }, 
  
  textual: {
    type: String
  }
},

computed: {
  roundedSpeed(){
    return Math.round(this.speed)
  },
}
}
</script>

<style lang="sass">

.wind 
  display: flex 
  justify-content: center
  flex-direction: column
  
  &__speed 
    svg 
      margin-right: 8px
  
  &__direction 
    span, svg 
      font-size: $detail-size
      
    svg 
      margin: 0px 8px
  
</style>